import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import styles from "./add-staff.module.css";
import {
  Button,
  Col,
  DatePicker,
  Input,
  Row,
  Select,
  Form,
  Upload,
} from "antd";
import {
  CalendarOutlined,
  MailOutlined,
  PhoneOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import { Option } from "antd/es/mentions";
import CustomDrawer from "../../../../common/custom-drawer/custom-drawer";
import CustomButton from "../../../../common/custom-button/custom-button";
import { Controller, useForm } from "react-hook-form";
import { addStaff, getStaff } from "../../../../services/staff";
import { toast } from "react-toastify";
import CustomTextfield from "../../../../common/input/custom-textfield/custom-textfield";
import CustomSelect from "../../../../common/input/custom-select/custom-select";
import {
  genderOptions,
  gendersList,
  maritalStatusList,
  religionsList,
  staffRolesList,
} from "../../../../constants/common";
import { getDepartments } from "../../../../services/departments";

const AddStaff = ({ open, onClose }) => {
  const [loading, setLoading] = useState(false);
  const [staffList, setStaffList] = useState([]);
  const [departmentsList, setDepartmentsList] = useState([]);

  const {
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    defaultValues: {
      role: "",
      department: "",
      full_name: "",
      gender: "",
      date_of_birth: "",
      profile_picture: null,
      religion: "",
      nationality: "",
      national_id_number: "",
      marital_status: "",
      address: "",
      phone_number: "",
      email_address: "",
      emergency_phone_number: "",
      emergency_contact_person: "",
      bank_name: "",
      bank_account_number: "",
      bank_branch_code: "",
      ifsc_code: "",
      subjects_taught: "",
      joining_date: "",
      previous_school_name: "",
      report_card_or_academic_records: null,
      transfer_certificate: null,
      allergies: "",
      medical_aid_name_and_number: "",
      blood_group: "",
      medical_certificate: null
    },
  });

  const getStaffList = async () => {
    try {
      setLoading(true);
      const response = await getStaff();
      if (response?.data) {
        setStaffList("YOU MAY FETCH AND SET HERE");
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error", error);
    }
  };

  const getDepartmentsList = async () => {
    try {
      setLoading(true);
      const response = await getDepartments();
      if (response?.data) {
        setDepartmentsList("YOU MAY FETCH AND SET HERE");
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error", error);
    }
  };

  const onSubmit = async (values) => {
    console.log("Form Submitted:", values);
    try {
      setLoading(true);
      const response = await addStaff(values);
      if (response?.data) {
        toast.success("Staff Added Successfully !");
        onClose();
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toast.error("Error! please try again");
      console.log("error", error);
    }
  };

  useEffect(() => {
    reset();
    getStaffList();
    getDepartmentsList();
  }, [open]);

  return (
    <CustomDrawer
      title="Add Staff"
      open={open}
      onClose={onClose}
      footer={
        <div className={styles.footer}>
          <CustomButton title="Add Staff" onClick={handleSubmit(onSubmit)} />
        </div>
      }
      loading={loading}
      className={styles.drawer}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <Row gutter={[16, 16]}>
        <Col span={12}>
            <Controller
              name="role"
              control={control}
              rules={{ required: true }}
              render={({
                field: { onChange, value },
                fieldState: { error },
              }) => (
                <CustomSelect
                  id="role"
                  placeholder="--Select--"
                  size="large"
                  label="Select Role"
                  value={value}
                  style={{ width: "100%" }}
                  onChange={onChange}
                  status={error ? "error" : ""}
                  labelColor="#667085"
                  showSearch={true}
                >
                  {staffRolesList.map((item, index) => (
                    <Option key={index} value={item?.value}>
                      {item?.label}
                    </Option>
                  ))}
                </CustomSelect>
              )}
            />
          </Col>
          <Col span={12}>
            <Controller
              name="department"
              control={control}
              rules={{ required: true }}
              render={({
                field: { onChange, value },
                fieldState: { error },
              }) => (
                <CustomSelect
                  id="department"
                  placeholder="--Select--"
                  size="large"
                  label="Select Department"
                  value={value}
                  style={{ width: "100%" }}
                  onChange={onChange}
                  status={error ? "error" : ""}
                  labelColor="#667085"
                  showSearch={true}
                >
                  {departmentsList.map((item, index) => (
                    <Option key={index} value={item?.value}>
                      {item?.label}
                    </Option>
                  ))}
                </CustomSelect>
              )}
            />
          </Col>
          <h3 className={styles.heading}>
            <span className={styles.dummy_green_rectangle}></span>
            <span>Personal Information:</span>
          </h3>

          <Col span={12}>
            <Controller
              name="full_name"
              control={control}
              rules={{ required: true }}
              render={({
                field: { onChange, value },
                fieldState: { error },
              }) => (
                <CustomTextfield
                  id="full_name"
                  label="Full Name"
                  labelColor="#667085"
                  placeholder="Enter full name"
                  size="large"
                  value={value}
                  onChange={onChange}
                  status={error ? "error" : ""}
                />
              )}
            />
          </Col>

          <Col span={12}>
            <Controller
              name="gender"
              control={control}
              rules={{ required: true }}
              render={({
                field: { onChange, value },
                fieldState: { error },
              }) => (
                <CustomSelect
                  id="gender"
                  placeholder="--Select--"
                  size="large"
                  label="Select Gender"
                  value={value}
                  style={{ width: "100%" }}
                  onChange={onChange}
                  status={error ? "error" : ""}
                  labelColor="#667085"
                  showSearch={true}
                >
                  {gendersList.map((item, index) => (
                    <Option key={index} value={item?.value}>
                      {item?.label}
                    </Option>
                  ))}
                </CustomSelect>
              )}
            />
          </Col>

          <Col span={12}>
            <label
              htmlFor="date_of_birth"
              style={{
                display: "block",
                marginBottom: 8,
                color: "#667085",
                fontWeight: 600,
              }}
            >
              Date of Birth
            </label>
            <Controller
              name="date_of_birth"
              control={control}
              rules={{ required: true }}
              render={({
                field: { onChange, value },
                fieldState: { error },
              }) => (
                <Input
                  id="date_of_birth"
                  placeholder="DD-MM-YY"
                  size="large"
                  value={value}
                  style={{ width: "100%" }}
                  onChange={onChange}
                  status={error ? "error" : ""}
                  prefix={<CalendarOutlined style={{ color: "#999" }} />}
                />
              )}
            />
          </Col>

          <Col span={12}>
            <label htmlFor="profile_picture"
              style={{
                display: "block",
                marginBottom: 8,
                color: "#667085",
                fontWeight: 600,
              }}>
              Profile Picture (jpg, png)
              </label>
            <Controller
              name="profile_picture"
              control={control}
              rules={{ required: true }}
              render={({
                field: { onChange, value },
                fieldState: { error },
              }) => (
                <Upload
                  beforeUpload={(file) => {
                    onChange(file);
                    return false;
                  }}
                  showUploadList={false}
                  accept=".jpg,.png"
                  value={value}
                  onChange={onChange}
                  status={error ? "error" : ""}
                  className={styles.common_input_styles}
                >
                  <Button
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      width: "100%",
                    }}
                  >
                    <span>Select a file to Upload</span>
                    <UploadOutlined />
                  </Button>
                </Upload>
              )}
            />
          </Col>

          <Col span={12}>
            <Controller
              name="religion"
              control={control}
              rules={{required: true}}
              render={({
                field: { onChange, value },
                fieldState: { error },
              }) => (
                <CustomSelect
                  placeholder="--Select--"
                  style={{ width: "100%" }}
                  id="religion"
                  size="large"
                  label={"Religion"}
                  value={value}
                  onChange={onChange}
                  status={error ? "error" : ""}
                  labelColor="#667085"
                  showSearch={true}
                >
                  {religionsList.map((item, index) => (
                    <Option key={index} value={item?.value}>
                      {item?.value}
                    </Option>
                  ))}
                </CustomSelect>
              )}
            />
          </Col>

          <Col span={12}>
            <Controller
              name="nationality"
              control={control}
              rules={{required: true}}
              render={({
                field: { onChange, value },
                fieldState: { error },
              }) => (
                <CustomTextfield
                  id="nationality"
                  label="Nationality"
                  labelColor="#667085"
                  placeholder="Enter nationality"
                  size="large"
                  value={value}
                  onChange={onChange}
                />
              )}
            />
          </Col>

          <Col span={12}>
            <Controller
              name="national_id_number"
              control={control}
              rules={{ required: true }}
              render={({
                field: { onChange, value },
                fieldState: { error },
              }) => (
                <CustomTextfield
                  id="national_id_number"
                  label="National ID number"
                  labelColor="#667085"
                  placeholder="Enter National ID number"
                  size="large"
                  value={value}
                  onChange={onChange}
                />
              )}
            />
          </Col>

          <Col span={12}>
            <Controller
              name="marital_status"
              control={control}
              rules={{ required: true }}
              render={({
                field: { onChange, value },
                fieldState: { error },
              }) => (
                <CustomSelect
                  placeholder="--Select--"
                  style={{ width: "100%" }}
                  id="marital_status"
                  size="large"
                  label={"Marital Status"}
                  value={value}
                  onChange={onChange}
                  status={error ? "error" : ""}
                  labelColor="#667085"
                  showSearch={true}
                >
                  {maritalStatusList.map((item, index) => (
                    <Option key={index} value={item?.value}>
                      {item?.value}
                    </Option>
                  ))}
                </CustomSelect>
              )}
            />
          </Col>

          <h3 className={styles.heading}>
            <span className={styles.dummy_green_rectangle}></span>
            <span>Contact Information:</span>
          </h3>

          <Col span={24}>
            <Controller
              name="address"
              control={control}
              rules={{ required: true }}
              render={({
                field: { onChange, value },
                fieldState: { error },
              }) => (
                <CustomTextfield
                  id="address"
                  label="Full Address"
                  labelColor="#667085"
                  placeholder="Enter address"
                  size="large"
                  value={value}
                  onChange={onChange}
                />
              )}
            />
          </Col>

          <Col span={12}>
            <Controller
              name="phone_number"
              control={control}
              rules={{ required: true }}
              render={({
                field: { onChange, value },
                fieldState: { error },
              }) => (
                <CustomTextfield
                  id="phone_number"
                  label="Phone Number"
                  labelColor="#667085"
                  placeholder="Enter phone number"
                  size="large"
                  prefix={<PhoneOutlined style={{ transform: "scaleX(-1)" }} />}
                  value={value}
                  onChange={onChange}
                  status={error ? "error" : ""}
                />
              )}
            />
          </Col>

          <Col span={12}>
            <Controller
              name="email_address"
              control={control}
              rules={{ required: true }}
              render={({
                field: { onChange, value },
                fieldState: { error },
              }) => (
                <CustomTextfield
                  id="email_address"
                  label="Email"
                  labelColor="#667085"
                  placeholder="Enter email"
                  size="large"
                  prefix={<PhoneOutlined style={{ transform: "scaleX(-1)" }} />}
                  value={value}
                  onChange={onChange}
                  status={error ? "error" : ""}
                />
              )}
            />
          </Col>

          <Col span={12}>
            <Controller
              name="emergency_phone_number"
              control={control}
              rules={{ required: true }}
              render={({
                field: { onChange, value },
                fieldState: { error },
              }) => (
                <CustomTextfield
                  id="emergency_phone_number"
                  label="Emergency Phone Number"
                  labelColor="#667085"
                  placeholder="Enter phone number"
                  size="large"
                  prefix={<PhoneOutlined style={{ transform: "scaleX(-1)" }} />}
                  value={value}
                  onChange={onChange}
                  status={error ? "error" : ""}
                />
              )}
            />
          </Col>

          <Col span={12}>
            <Controller
              name="emergency_contact_person"
              control={control}
              rules={{ required: true }}
              render={({
                field: { onChange, value },
                fieldState: { error },
              }) => (
                <CustomTextfield
                  id="emergency_contact_person"
                  label="Emergency Contact Person"
                  labelColor="#667085"
                  placeholder="Enter name"
                  size="large"
                  value={value}
                  onChange={onChange}
                />
              )}
            />
          </Col>

          <h3 className={styles.heading}>
            <span className={styles.dummy_green_rectangle}></span>
            <span>Bank Account Details:</span>
          </h3>

          <Col span={12}>
            <Controller
              name="bank_name"
              control={control}
              rules={{ required: true }}
              render={({
                field: { onChange, value },
                fieldState: { error },
              }) => (
                <CustomTextfield
                  id="bank_name"
                  label="Bank Name"
                  labelColor="#667085"
                  placeholder="Enter name"
                  size="large"
                  value={value}
                  onChange={onChange}
                />
              )}
            />
          </Col>

          <Col span={12}>
            <Controller
              name="bank_account_number"
              control={control}
              rules={{ required: true }}
              render={({
                field: { onChange, value },
                fieldState: { error },
              }) => (
                <CustomTextfield
                  id="bank_account_number"
                  label="Account Number"
                  labelColor="#667085"
                  placeholder="Enter account number"
                  size="large"
                  value={value}
                  onChange={onChange}
                />
              )}
            />
          </Col>

          <Col span={12}>
            <Controller
              name="bank_branch_code"
              control={control}
              rules={{ required: true }}
              render={({
                field: { onChange, value },
                fieldState: { error },
              }) => (
                <CustomTextfield
                  id="bank_branch_code"
                  label="Branch Code"
                  labelColor="#667085"
                  placeholder="Enter branch code"
                  size="large"
                  value={value}
                  onChange={onChange}
                />
              )}
            />
          </Col>

          <Col span={12}>
            <Controller
              name="ifsc_code"
              control={control}
              rules={{ required: true }}
              render={({
                field: { onChange, value },
                fieldState: { error },
              }) => (
                <CustomTextfield
                  id="ifsc_code"
                  label="IFSC Code"
                  labelColor="#667085"
                  placeholder="Enter IFSC Code"
                  size="large"
                  value={value}
                  onChange={onChange}
                />
              )}
            />
          </Col>

          <h3 className={styles.heading}>
            <span className={styles.dummy_green_rectangle}></span>
            <span>Academic Information:</span>
          </h3>

          <Col span={12}>
            <Controller
              name="subjects_taught"
              control={control}
              rules={{ required: true }}
              render={({
                field: { onChange, value },
                fieldState: { error },
              }) => (
                <CustomTextfield
                  id="subjects_taught"
                  label="Subject(s) Taught"
                  labelColor="#667085"
                  placeholder="Enter subjects"
                  size="large"
                  value={value}
                  onChange={onChange}
                />
              )}
            />
          </Col>

          <Col span={12}>
            <label
              htmlFor="joining_date"
              style={{
                display: "block",
                marginBottom: 8,
                color: "#667085",
                fontWeight: 600,
              }}
            >
              Joining Date
            </label>
            <Controller
              name="joining_date"
              control={control}
              rules={{ required: true }}
              render={({
                field: { onChange, value },
                fieldState: { error },
              }) => (
                <Input
                  id="joining_date"
                  placeholder="DD-MM-YY"
                  size="large"
                  value={value}
                  style={{ width: "100%" }}
                  onChange={onChange}
                  status={error ? "error" : ""}
                  prefix={<CalendarOutlined style={{ color: "#999" }} />}
                />
              )}
            />
          </Col>

          <Col span={12}>
            <Controller
              name="previous_school_name"
              control={control}
              rules={{ required: true }}
              render={({
                field: { onChange, value },
                fieldState: { error },
              }) => (
                <CustomTextfield
                  id="previous_school_name"
                  label="Previous School Name"
                  labelColor="#667085"
                  placeholder="Enter school name"
                  size="large"
                  value={value}
                  onChange={onChange}
                  status={error ? "error" : ""}
                />
              )}
            />
          </Col>

          <Col span={12}>
            <label
              htmlFor="report_card_or_academic_records"
              style={{
                display: "block",
                marginBottom: 8,
                color: "#667085",
                fontWeight: 600,
              }}
            >
              Report card or academic records (jpg, png, pdf)
            </label>
            <Controller
              name="report_card_or_academic_records"
              control={control}
              rules={{ required: true }}
              render={({
                field: { onChange, value },
                fieldState: { error },
              }) => (
                <Upload
                  beforeUpload={(file) => {
                    onChange(file);
                    return false;
                  }}
                  showUploadList={false}
                  accept=".jpg,.png,.pdf"
                  value={value}
                  onChange={onChange}
                  status={error ? "error" : ""}
                  className={styles.common_input_styles}
                >
                  <Button
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      width: "100%",
                    }}
                  >
                    <span>Select a file to Upload</span>
                    <UploadOutlined />
                  </Button>
                </Upload>
              )}
            />
          </Col>

          <Col span={12}>
            <label
              htmlFor="transfer_certificate"
              style={{
                display: "block",
                marginBottom: 8,
                color: "#667085",
                fontWeight: 600,
              }}
            >
              Transfer Certificate (jpg, png, pdf)
            </label>
            <Controller
              name="transfer_certificate"
              control={control}
              rules={{ required: true }}
              render={({
                field: { onChange, value },
                fieldState: { error },
              }) => (
                <Upload
                  beforeUpload={(file) => {
                    onChange(file);
                    return false;
                  }}
                  showUploadList={false}
                  accept=".jpg,.png,.pdf"
                  value={value}
                  onChange={onChange}
                  status={error ? "error" : ""}
                  className={styles.common_input_styles}
                >
                  <Button
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      width: "100%",
                    }}
                  >
                    <span>Select a file to Upload</span>
                    <UploadOutlined />
                  </Button>
                </Upload>
              )}
            />
          </Col>

          <h3 className={styles.heading}>
            <span className={styles.dummy_green_rectangle}></span>
            <span>Medical Information:</span>
          </h3>

          <Col span={12}>
            <Controller
              name="allergies"
              control={control}
              rules={{ required: true }}
              render={({
                field: { onChange, value },
                fieldState: { error },
              }) => (
                <CustomTextfield
                  id="allergies"
                  label="Allergies"
                  labelColor="#667085"
                  placeholder="Enter what type of allergy you have"
                  size="large"
                  value={value}
                  onChange={onChange}
                />
              )}
            />
          </Col>

          <Col span={12}>
            <Controller
              name="medical_aid_name_and_number"
              control={control}
              rules={{ required: true }}
              render={({
                field: { onChange, value },
                fieldState: { error },
              }) => (
                <CustomTextfield
                  id="medical_aid_name_and_number"
                  label="Medical Aid Name and Number"
                  labelColor="#667085"
                  placeholder="Enter medical aid name and number"
                  size="large"
                  value={value}
                  onChange={onChange}
                />
              )}
            />
          </Col>

          <Col span={12}>
            <Controller
              name="bloodGroup"
              control={control}
              rules={{ required: true }}
              render={({
                field: { onChange, value },
                fieldState: { error },
              }) => (
                <CustomTextfield
                  id="bloodGroup"
                  label="Blood Group"
                  labelColor="#667085"
                  placeholder="Enter blood group"
                  size="large"
                  value={value}
                  onChange={onChange}
                />
              )}
            />
          </Col>
          <Col span={12}>
            <label
              htmlFor="medical_certificate"
              style={{
                display: "block",
                marginBottom: 8,
                color: "#667085",
                fontWeight: 600,
              }}
            >
              Upload Medical Certificate (jpg, png, pdf)
            </label>
            <Controller
              name="medical_certificate"
              control={control}
              rules={{ required: true }}
              render={({
                field: { onChange, value },
                fieldState: { error },
              }) => (
                <Upload
                  beforeUpload={(file) => {
                    onChange(file);
                    return false;
                  }}
                  showUploadList={false}
                  accept=".jpg,.png,.pdf"
                  value={value}
                  onChange={onChange}
                  status={error ? "error" : ""}
                  className={styles.common_input_styles}
                >
                  <Button
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      width: "100%",
                    }}
                  >
                    <span>Select a file to Upload</span>
                    <UploadOutlined />
                  </Button>
                </Upload>
              )}
            />
          </Col>
        </Row>
      </form>
    </CustomDrawer>
  );
};

AddStaff.propTypes = {};

AddStaff.defaultProps = {};

export default AddStaff;
